import { render, staticRenderFns } from "./productBlock.vue?vue&type=template&id=561d5aeb&"
import script from "./productBlock.vue?vue&type=script&lang=js&"
export * from "./productBlock.vue?vue&type=script&lang=js&"
import style0 from "./productBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports